import type { GetMainMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';
import { APIComponentAttributes } from '@ardoq/api-types';
import { IconName } from '@ardoq/icons';
import { t } from '@ardoq/i18n';
import { toColumnMenuItemDef } from './CustomColumnMenuItem';
import { bulkEditFieldOperations } from '../updateComponents/bulkEditField/bulkEditFieldOperations';
import { openBulkEditFieldDialog } from '../updateComponents/bulkEditField/openBulkEditFieldDialog';
import type { InventoryContext } from '../types';
import { refreshServerSideForGrid } from '../serverSideRefresh';

export const getBulkEditFieldMenuItem = (
  params: GetMainMenuItemsParams<APIComponentAttributes, InventoryContext>
): MenuItemDef<APIComponentAttributes> | null => {
  const { shouldDisplayBulkEditOptions } = params.context.config;
  const colDef = params.column?.getColDef();

  if (
    !shouldDisplayBulkEditOptions ||
    !colDef?.field ||
    !bulkEditFieldOperations.isBulkEditableColumn({
      colDef,
      context: params.context,
    })
  ) {
    return null;
  }

  const columnKey = colDef.field;
  const i18nLocale = params.context.i18nLocale ?? {};
  const allBulkEditableColumns = bulkEditFieldOperations.getBulkEditableColumns(
    params.api,
    params.context,
    params.context.config.locale
  );

  return toColumnMenuItemDef({
    name: t(
      i18nLocale,
      'inventoryApp:ag.columnMenu.bulkEditField',
      'Bulk edit field'
    ),
    iconName: IconName.EDIT,
    action: () => {
      openBulkEditFieldDialog({
        allBulkEditableColumns,
        i18nLocale,
        locale: params.context.config.locale,
        commands: params.context.commands,
        preselectedColumnKey: columnKey,
        refreshServerSideForGridCallback: () =>
          refreshServerSideForGrid(params.api),
      });
    },
  });
};
